import Icon from '../components/Icon.vue'

Icon.register({
  donate: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 416C370.9 416 464 322.9 464 208S370.9 0 256 0 48 93.1 48 208 141.1 416 256 416zM233.8 97.4V80.6C233.8 71.4 241.2 64 250.4 64H261.5C270.7 64 278.1 71.4 278.1 80.6V97.6C293.6 98.4 308.6 103.7 321.1 113 326.7 117.1 327.3 125.3 322.3 130.1L306 145.6C302.2 149.3 296.5 149.4 292 146.6 286.6 143.2 280.6 141.5 274.2 141.5H235.3C226.3 141.5 219 149.7 219 159.8 219 168 224 175.3 231.1 177.4L293.4 196.1C319.1 203.8 337.1 228.5 337.1 256.2 337.1 290.2 310.7 317.7 278 318.6V335.4C278 344.6 270.6 352 261.4 352H250.3C241.1 352 233.7 344.6 233.7 335.4V318.4C218.2 317.6 203.2 312.3 190.7 303 185.1 298.9 184.5 290.7 189.5 285.9L205.8 270.4C209.6 266.7 215.3 266.6 219.8 269.4 225.2 272.8 231.2 274.5 237.6 274.5H276.5C285.5 274.5 292.8 266.3 292.8 256.2 292.8 248 287.8 240.7 280.7 238.6L218.4 219.9C192.7 212.2 174.7 187.5 174.7 159.8 174.8 125.8 201.1 98.3 233.8 97.4zM480 352H447.5C427.9 378 402.9 399.7 374.5 416H438.3C443.6 416 447.9 419.6 447.9 424V440C447.9 444.4 443.6 448 438.3 448H73.6C68.3 448 64 444.4 64 440V424C64 419.6 68.3 416 73.6 416H137.4C109 399.7 84.1 378 64.4 352H32C14.3 352 0 366.3 0 384V480C0 497.7 14.3 512 32 512H480C497.7 512 512 497.7 512 480V384C512 366.3 497.7 352 480 352z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/donate.js
// module id = mTEy
// module chunks = 144